import { ContentContainer } from "@/components/ContentContainer";
import LinkStyled from "@/components/LinkStyled";
import PageHead from "@/components/PageHead";
import RegisterForm from "@/components/register/RegisterForm";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import theme from "../../styles/theme";

const Register = ({ page }) => {
  return (
    <>
      <PageHead page={page} />
      <ContentContainer headline={page?.headline}>
        <Typography
          variant="body2"
          sx={{
            mb: 3,
            [theme.breakpoints.up("sm")]: {
              mb: 6,
            },
          }}
        >
          {page?.description}
        </Typography>

        <RegisterForm />

        <Box sx={{ mt: 4 }}>
          <Divider>Bereits registriert?</Divider>
          <Typography variant="body1" textAlign="center">
            Du bist bereits registriert?{" "}
            <LinkStyled href="/login" label="Zum Login" />
          </Typography>
        </Box>
      </ContentContainer>
    </>
  );
};

export default Register;

export const getStaticProps = async () => {
  const pageResponse = await fetch(
    `${
      process.env.NEXT_PUBLIC_API_URL || "http://localhost:1337"
    }/page-register`,
  );
  const page = await pageResponse.json();

  return {
    props: {
      page,
    },
    revalidate: parseInt(process.env.SSG_REVALIDATE_TIMEOUT),
  };
};
